import styled from "styled-components";

export default styled.span`
  display: flex;
  font-size: 12px;
  color: #9fafb6;
  margin-right: 16px;
`;
